<template>
	<section>
		<b-modal
			ref="modalLogin"
			:ok-title="this.$t('login.access')"
			hide-header
			hide-footer
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-backdrop
		>
			<b-overlay :show="loading" no-wrap></b-overlay>
			<div class="text-center">
				<img :src="logo" style="max-width: 300px"><br>
				<h6 class="mt-2 mb-3">{{ this.$t('global.pointOfSale') }}</h6>
			</div>
			<hr>
			<b-form ref="loginForm" @submit="onSubmit">
				<div class="row justify-content-md-center">
					<div class="col-sm-8 mx-auto">
						<b-form-group :label="this.$t('global.email')">
							<b-form-input
								v-model="form.email"
								type="text"
								required
							></b-form-input>
						</b-form-group>
						<b-form-group :label="this.$t('users.password')">
							<b-form-input
								v-model="form.password"
								type="password"
								required
							></b-form-input>
						</b-form-group>
					</div>
				</div>
				<div class="text-center mt-2 mb-3">
					<p class="text-danger" v-if="error">{{ this.$t('login.wrongLogin') }}</p>
					<a href="/reset-passwd" @click="$root.setRouteEvt">{{ this.$t('login.forgetPassword') }}</a>
				</div>
				<hr>
				<div class="text-center py-2">
					<b-button variant="primary" block type="submit">{{ this.$t('login.access') }}</b-button>
				</div>
			</b-form>
		</b-modal>

		<Single ref="single"/>
	</section>
</template>

<script>
import logo from '../../../assets/logo-sc-negro.png'
import Single from "./Single";

export default {
	components: {Single},
	data() {
		return {
			logo,
			form: {
				email: '',
				password: '',
			},
			error: false,
			loading: false,
		}
	},
	methods: {
		onSubmit(evt) {
			evt.preventDefault();
			this.error = false;
			this.loading = true;
			// get token
			this.$root.api.post('/auth/login', this.form).then((res) => {
				// check if user has options
				if(res.data.options.pos === null)
					this.$root.showAlert(this.$t('accessDenied.accessDenied'), {variant: 'warning'})

				// validate if has more than 1 access
				if(res.data.options.pos.length === 1) {
					//set user token
					this.$root.store.setUserToken(res.data.token.access_token)

					let system = res.data.options.pos[0].id
					this.$root.api.post('/auth/system', null, {
						headers: {
							"X-SC-TYPE": 'pos',
							"X-SC-SYSTEM": system,
						}
					}).then((response) => {
						this.$root.store.setSystemData(response.data)

						this.$root.api.post('/auth/me').then((response2) => {
							this.$root.store.setUserData(response2.data)
							this.$router.push('/')
						})
					}).catch(() => {
						this.loading = false;
						this.error = true;
					})
				} else if(res.data.options.pos.length > 1) {
					// show modal & set user token
					this.$root.store.setUserToken(res.data.token.access_token)
					this.$refs["single"].loadModel(res.data.options);
				}

				this.loading = false;
			}).catch(() => {
				this.loading = false;
				this.error = true;
			})
		},
	},
	mounted() {
		this.$refs['modalLogin'].show();
	},
	beforeCreate() { // access from suppliers
		if (Object.entries(this.$route.query).length !== 0 && this.$route.query.referenceId && this.$route.query.token) {
			this.loading = true

			let token = typeof this.$route.query.token !== 'string' ? null : this.$route.query.token
			let referenceId = typeof this.$route.query.referenceId !== 'string' ? null : this.$route.query.referenceId

			if (referenceId !== null && token !== null) {
				// set token
				this.$root.store.setUserToken(token)

				this.$root.api.post('/auth/system', null, {
					headers: {
						"X-SC-TYPE": 'pos',
						"X-SC-SYSTEM": referenceId,
					}
				}).then((response) => {
					// set system data
					this.$root.store.setSystemData(response.data)

					this.$root.api.post('/auth/me').then((response2) => {
						this.$root.store.setUserData(response2.data)
						this.$router.push('/')
						this.loading = false
					})
					this.loading = false;
				}).catch(() => {
					this.loading = false;
					this.error = true;
				})
			}
		}  else {
			this.$root.auxVars.clearResources();
			this.$root.store.clearUser();
		}
	}
}
</script>

<style>

</style>
